export var BHost = 'doc.weixin.qq.com';
export var CHost = 'docs.qq.com';